import React, {
  memo, useState, useCallback,
} from 'react';
import PropTypes from 'prop-types';
import './ren-overflowing-text.scss';
import AnimateHeight from '../animate-height';
import Typography from '../typography';
import Button, {
  ButtonAppearance, ButtonSizes, ButtonTypes,
} from '../button';
import useTranslation from '../../../utils/translation-utils';
import { DEFAULT_TEXT_STYLES } from './constants';

/* eslint-disable react/jsx-props-no-spreading */
const RenOverflowingText = ({ value, textProps }) => {
  const [getTranslation] = useTranslation();
  const [showMore, setShowMore] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const toggleShowMore = useCallback(() => (
    setShowMore(!showMore)
  ), [showMore]);

  const remarksRef = (event) => {
    if (value && (event?.textContent !== value || showMore)) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  return (
    <AnimateHeight>
      <div className="ren-overflowing-text">
        <Typography
          {...textProps}
          ref={remarksRef}
          className="rot-text"
          rows={showMore ? Infinity : textProps.rows}
        >
          {value}
        </Typography>
        {showButton && (
          <Button
            borderLess
            className="rot-button"
            onClick={toggleShowMore}
            size={ButtonSizes.X_SMALL}
            type={ButtonTypes.PRIMARY}
            appearance={ButtonAppearance.TEXT}
            label={showMore ? getTranslation('VIEW_LESS') : getTranslation('VIEW_MORE')}
          />
        )}
      </div>
    </AnimateHeight>
  );
};

RenOverflowingText.defaultProps = {
  value: '',
  textProps: DEFAULT_TEXT_STYLES,
};

RenOverflowingText.propTypes = {
  value: PropTypes.string,
  textProps: PropTypes.shape({
    rows: PropTypes.number,
  }),
};

export default memo(RenOverflowingText);
